import type { IProductivityMetric } from '@interfaces/IProductivity';
import { MetricCard } from './MetricCard/MetricCard';
import styles from './MetricStrip.module.css';

interface IMetricStripProps {
  metrics: IProductivityMetric[];
}

const REAL_METRICS = new Set([
  'project-productivity',
  'location-utilization',
  'workers-on-site',
  'performance-extremes',
]);

/**
 * The summary strip under the page header — one reusable MetricCard per
 * entry. Five today, but it renders whatever the data array holds.
 */
export function MetricStrip({ metrics }: IMetricStripProps) {
  return (
    <section className={styles.strip}>
      {metrics.map((metric) => (
        <MetricCard key={metric.id} metric={metric} mock={!REAL_METRICS.has(metric.id)} />
      ))}
    </section>
  );
}